import SearchForm from '../../model/search-form';

export default class InvoiceSearchForm implements SearchForm {
  private readonly submittedDateFrom: JQuery;
  private readonly submittedDateUntil: JQuery;
  private readonly id: JQuery;
  private readonly submitBtn: JQuery;

  constructor(private form: JQuery<HTMLFormElement>) {
    this.submittedDateFrom = this.form.find('.js-submittedDateFrom');
    this.submittedDateUntil = this.form.find('.js-submittedDateUntil');
    this.id = this.form.find('.js-id');
    this.submitBtn = this.form.find('.js-submitBtn');

    const datepickerOptions = { maxDate: '0D' };
    this.submittedDateFrom.datepicker('option', datepickerOptions);
    this.submittedDateUntil.datepicker('option', datepickerOptions);

    this.prepareForm();
    this.bindValidateForm();
  }

  getForm(): JQuery<HTMLFormElement> {
    return this.form;
  }

  submit(): void {
    this.form.submit();
  }

  private bindValidateForm() {
    this.form.on('change', () => {
      this.prepareForm();
    });
  }

  private prepareForm() {
    const dateFrom = this.submittedDateFrom.datepicker('getDate');
    if (dateFrom) {
      this.submittedDateUntil.datepicker('option', { minDate: dateFrom });
    }
    this.submitBtn.prop('disabled', !this.isFormValid());
  }

  private isFormValid() {
    let isValid = false;

    // eslint-disable-next-line eqeqeq
    if ((this.id.val() !== '' && this.submittedDateFrom.val() == '' && this.submittedDateUntil.val() == '') || (this.submittedDateFrom.val() !== '' && this.submittedDateUntil.val() !== '')) {
      isValid = true;
    }

    return isValid;
  }
}
